var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('span',{staticClass:"material-icons empty-icon",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.icon))]),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }